module.exports = __webpack_public_path__ + "img/vannkraft_smvf.735d6175.jpg";